import React, { useState } from "react"
import {
  AppBar,
  Button,
  Box,
  Typography,
  Stack,
  IconButton,
} from "@mui/material"
import { NavLink, useNavigate } from "react-router-dom"
import logo from "../../images/nav/logo.svg"
import { images } from "../../images/about/index"
import { BsList } from "react-icons/bs"
import { BsChevronRight } from "react-icons/bs"
// import { BsXLg } from "react-icons/bs"
import AppDrawer from "./drawer"
// import styles from "./nav.module.css"

export default function NavBar({ dark, ...props }) {
  const [drawer, setDrawer] = useState(false)
  const toggleDrawer = () => setDrawer(!drawer)

  const navigate = useNavigate()

  const handleHome = () => {
    navigate("/")
  }

  const handleService = () => {
    navigate("/service")
  }

  const handlePricing = () => {
    navigate("/pricing")
  }

  const handleAbout = () => {
    navigate("/about")
  }

  const handleContact = () => {
    navigate("/contact")
  }

  // const [toggle, setToggle] = useState(false)

  return (
    <AppBar
      position="relative"
      sx={{ zIndex: "1" }}
      color="transparent"
      elevation={0}
    >
      <Stack
        direction="row"
        justifyContent={"space-between"}
        alignItems="center"
        spacing={"5px"}
        paddingY={{ xs: "14px", sm: "22px", md: "31px" }}
        paddingX={{ xs: "23px", md: "36px" }}
        sx={{ filter: "brightness(100%)" }}
      >
        <Box>
          <NavLink to={"/"} style={{ textDecoration: "none" }}>
            <img src={dark ? logo : images.logo} alt="logo" height={40} />
            {/* <img src={images.logo} alt="logo" height={40} /> */}
          </NavLink>
        </Box>
        <Stack
          direction={"row"}
          spacing={"44px"}
          color={dark ? "white" : "black"}
          sx={{
            display: { xs: "none", md: "flex" },
            alignItems: "center",
          }}
        >
          <Typography onClick={handleHome} sx={{ cursor: "pointer" }}>
            Home
          </Typography>
          <Typography
            onClick={handleAbout}
            sx={{ cursor: "pointer", textDecoration: "none" }}
          >
            About
          </Typography>
          <Typography onClick={handleService} sx={{ cursor: "pointer" }}>
            Service
          </Typography>
          <Typography onClick={handlePricing} sx={{ cursor: "pointer" }}>
            Pricing
          </Typography>
          <Typography onClick={handleContact} sx={{ cursor: "pointer" }}>
            Contact
          </Typography>
          <Button
            href="https://business.wallx.co"
            target="_blank"
            sx={{
              display: "flex",
              cursor: "pointer",
              justifyContent: "space-around",
              border: "1px solid #fff",
              pr: 2,
              pl: 2,
              borderRadius: "20px",
              background: `${dark ? "#fff" : "#7E7ACD"}`,
              ":hover": {
                color: dark ? "#fff" : "#7E7ACD",
                backgroundColor: dark ? "" : "#7E7ACD",
                borderColor: dark ? "#fff" : "#7E7ACD",
              },
            }}
          >
            <span style={{ color: `${dark ? "#7E7ACD" : "#fff"}` }}>Login</span>
            <span
              style={{
                color: "#fff",
                marginLeft: "10px",
                background: "#7E7ACD",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                padding: "5px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                fontWeight: "bold",
              }}
            >
              <BsChevronRight />
            </span>
          </Button>
          {/* <Button
            sx={{
              display: "flex",
              cursor: "pointer",
              wordBreak: { xs: "normal", sm: "keep-all" },
              justifyContent: "space-around",
              border: "1px solid #fff",
              pr: 2,
              pl: 2,
              borderRadius: "20px",
              background: `${dark ? "#fff" : "#7E7ACD"}`,
              ":hover": {
                color: dark ? "#fff" : "#7E7ACD",
                backgroundColor: dark ? "" : "#7E7ACD",
                borderColor: dark ? "#fff" : "#7E7ACD",
              },
            }}
          >
            <span style={{ color: `${dark ? "#7E7ACD" : "#fff"}` }}>
              Get started
            </span>
            <span
              style={{
                color: "#fff",
                marginLeft: "10px",
                background: "#7E7ACD",
                width: "10px",
                height: "10px",
                borderRadius: "50%",
                padding: "5px",
                display: "flex",
                alignItems: "center",
                fontWeight: "bold",
              }}
            >
              <BsChevronRight />
            </span>
          </Button> */}
        </Stack>
        <IconButton
          onClick={toggleDrawer}
          sx={{
            display: {
              xs: "flex",
              md: "none",
              color: dark ? "white" : "black",
            },
          }}
        >
          <BsList
            // className={`${styles.toggle} ${dark ? styles.general : styles.about}`}
            size={40}
          />
        </IconButton>
      </Stack>

      <Box sx={{ width: "100%", textAlign: "end", mt: -6 }}></Box>

      <AppDrawer open={drawer} close={toggleDrawer} />
    </AppBar>
  )
}
